import { changeGleapBlockVisibility } from '../../utils';

export function* hideGleapBlock() {
  yield changeGleapBlockVisibility('hidden');
}
